// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dropdown-toggle[data-v-1164417e]:after{content:normal}#main[data-v-1164417e]{min-height:auto}.ec-success-container[data-v-1164417e]{align-items:center;display:flex;flex-flow:column;margin-bottom:20px}.ec-success-grid[data-v-1164417e]{padding:10px}.ec-success-grid--text[data-v-1164417e]{width:100%;word-wrap:break-word;max-width:700px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
